var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.067 20H6.001a.872.872 0 01-.855-.759L3.312 3.829a.492.492 0 11.976-.116l1.818 15.3h7.848l1.817-15.3a.492.492 0 11.976.116l-1.83 15.412a.872.872 0 01-.85.759z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.574 4.263H2.492a.492.492 0 110-.984h15.082a.492.492 0 010 .984z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.656 4.262a.492.492 0 01-.492-.492V1.147A.166.166 0 0012 .983H8.066a.166.166 0 00-.164.164V3.77a.492.492 0 01-.984 0V1.147A1.149 1.149 0 018.066-.001H12a1.149 1.149 0 011.148 1.148V3.77a.492.492 0 01-.492.492z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.fd878ccc0200a1774cd4ae5f5471541a.svg";
export { ForwardRef as ReactComponent };